$(document).ready(function() {
$('.drawer').drawer({speed: 400});
$('.drawer-nav').on('click', function() {$('.drawer').drawer('close');});
});

  (function(d) {
    var config = {
      kitId: 'cdq0hbs',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);

$(document).ready(function(){
$(".fv__back")
    .on("init", function () {
    $('.slick-slide[data-slick-index="0"] .animetion_content').addClass("zoomUp");
    })
    .slick({
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: 'linear'
    })
    .on({
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(nextSlide)
          .find(".animetion_content")
          .addClass("zoomUp");
        $(".slick-slide", this).eq(currentSlide)
          .find(".animetion_content")
          .addClass("zoomUp_Reset");
      },
      afterChange: function () {
        $(".zoomUp_Reset", this).removeClass("zoomUp_Reset zoomUp");
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
const body = document.body;
const hamburgerText = document.getElementById('hamburger-text');
const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (body.classList.contains('drawer-open')) {
                hamburgerText.textContent = 'CLOSE';
            } else {
                hamburgerText.textContent = 'MENU';
            }
        }
    });
});
observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
});
});

$(function () {
  var $btn = $('.drawer-hamburger');
  var visible = false;
  $btn.css({
    opacity: 0,
    display: 'block',
    pointerEvents: 'none'
  });
  $(window).on('scroll', function () {
    var w = $(window).width();
    if (w > 820) {
      if (visible) {
        $btn.stop(true, true).animate({ opacity: 0 }, 200, function () {
          $btn.css('pointer-events', 'none');
        });
        visible = false;
      }
      return;
    }

    var shouldShow = $(this).scrollTop() > 100;

    if (shouldShow !== visible) {
      visible = shouldShow;
      if (visible) {
        $btn
          .css('pointer-events', 'auto')
          .stop(true, true)
          .animate({ opacity: 1 }, 200);
      } else {
        $btn
          .stop(true, true)
          .animate({ opacity: 0 }, 200, function () {
            $btn.css('pointer-events', 'none');
          });
      }
    }
  });
});

